/** @jsxImportSource @emotion/react */

import Lottie from "lottie-react";
import React, { useState } from "react";
import { fromPublic, getLottieJson } from "../../utils";
import styled from "@emotion/styled";

const FullScreenImage = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none; 
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface ImageLottieProps {
  imageLottie?: string;
  fullScreen?: boolean;
  loop?: boolean;
}

const ImageLottie: React.FC<ImageLottieProps> = ({ imageLottie, fullScreen = false, loop = false }) => {
  const [isLottieVisible, setIsLottieVisible] = useState(true);

  if (!imageLottie) {
    return null;
  }

  const animationData = getLottieJson(fromPublic(imageLottie));
  const handleLottieAnimationComplete = () => {
    setIsLottieVisible(false);
  };



  return fullScreen ? (
    isLottieVisible ? (
      <FullScreenImage>
        <Lottie animationData={animationData} loop={loop} onComplete={handleLottieAnimationComplete} style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </FullScreenImage>
    ) : (
      <></>
    )
  ) : (
    <Lottie animationData={animationData} loop={loop} style={{ maxWidth: '100%', maxHeight: '100%' }} />
  );
};

export default ImageLottie;